<div class="habit-tab-block">
    <!-- <p class="text-14-400 color-12 mb-0 ri-py-2 ri-px-4 text-center bg-26">{{ ss.t('trash_itemEraseContent') }}</p> -->
    <div class="habit-trash-block ri-px-4 ri-pt-4 ri-bb-1 entity-block" *ngFor="let entity of deletedHabits(); let i = index; trackBy: trackByEntity;">
        <app-habit-block [entry]="entity.entityEntry" [show]="show()" [clickable]="false" [hideStatus]="true" (click)="openSetup(entity.entityId)"></app-habit-block>
        <p class="text-14-400 color-35 mb-0 ri-pt-2" role="button" (click)="openEntities(entity.entityId)">{{ ss.t('trash_entryCount', { count: entity.entries.length.toString() }) }}</p>
        <div class="flex items-center justify-around ri-pt-1">
            <button class="btn-text text-16-400 color-11 ri-px-8 ri-py-4" (click)="remove(entity.entityId)">{{
                ss.t('common_buttonRemove') }}</button>
            <button class="btn-text text-14-400 color-35 ri-px-8 ri-py-4" (click)="restore(entity.entityId)">{{
                ss.t('common_restore') }}</button>
        </div>
    </div>

    <div class="no-result-block h-full flex items-center justify-center flex-col" *ngIf="deletedHabits().length === 0">
        <app-svg [name]="'habitPlaceholder'" [color]="ss.theme().color1"></app-svg>
        <p class="text-16-400 color-8 mb-0 ri-pt-4">{{ ss.t('common_habitEmptyScreenContent') }}</p>
    </div>
</div>